import { IApplicationState } from '../../types/redux';

export const selectSubdomain = (defaultValue: string) => (state: IApplicationState) => {
  return state.buildersProjects.data.location?.subdomain ?? defaultValue;
};
